module.exports = __webpack_public_path__ + "static/media/serie.67c7bd62.png";